import { alpha, type Components, type Theme } from '@mui/material/styles'

import { statusToneStyles } from '@/themes/statusTone'

declare module '@mui/material/Chip' {
  interface ChipPropsVariantOverrides {
    status: true
  }
}

export const MuiChipOverride: Components<Theme>['MuiChip'] = {
  styleOverrides: {
    root: {
      borderRadius: 6,
      fontWeight: 500,
    },
  },
  variants: [
    {
      props: { variant: 'status', color: 'success' },
      style: ({ theme }) => statusToneStyles(theme, 'positive'),
    },
    {
      props: { variant: 'status', color: 'error' },
      style: ({ theme }) => statusToneStyles(theme, 'negative'),
    },
    {
      // Marks something as the chosen or primary one of a set, so it carries the
      // brand blue rather than a status colour.
      //
      // Deliberately not `info.light` / `info.dark` like the two above: those tokens
      // are surface tints — near-white and near-black — rather than lighter and
      // darker shades of the hue, so reading them here produced near-black text and
      // a murky border. The blue is taken from the palette's own brand colour, and
      // brightened in dark mode where the base shade is too dim to read.
      props: { variant: 'status', color: 'info' },
      style: ({ theme }) => {
        const color =
          theme.palette.mode === 'dark'
            ? theme.palette.primary.light
            : theme.palette.primary.main
        return {
          backgroundColor: alpha(color, theme.palette.mode === 'dark' ? 0.16 : 0.08),
          color,
          border: `1px solid ${color}`,
        }
      },
    },
  ],
}
